"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConfigContext = exports.ConfigContextProvider = exports.ConfigContext = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
exports.ConfigContext = (0, react_1.createContext)({});
const ConfigContextProvider = ({ children, config }) => {
    return (0, jsx_runtime_1.jsx)(exports.ConfigContext.Provider, { value: config, children: children });
};
exports.ConfigContextProvider = ConfigContextProvider;
const useConfigContext = () => {
    const context = (0, react_1.useContext)(exports.ConfigContext);
    if (!context) {
        throw new Error('Must use useConfigContext in ConfigContext');
    }
    return context;
};
exports.useConfigContext = useConfigContext;
//# sourceMappingURL=ConfigContext.js.map